(function () {
  'use strict';

  function initHBC(section) {
    var SECTION_ID = section.dataset.sectionId;

    var bgs        = Array.from(section.querySelectorAll('[data-lp-hbc-bg]'));
    var cardTexts  = Array.from(section.querySelectorAll('[data-lp-hbc-card-text]'));
    var prevBtn    = section.querySelector('#lp-hbc-prev-' + SECTION_ID);
    var nextBtn    = section.querySelector('#lp-hbc-next-' + SECTION_ID);
    var carouselEl = section.querySelector('#lp-hbc-card-' + SECTION_ID);
    var bgDots     = Array.from(section.querySelectorAll('[data-lp-hbc-bg-dot]'));
    var bgTotal    = bgs.length;
    var cardTotal  = cardTexts.length;
    var bgCurrent  = 0;
    var autoSpeed  = 7000;
    var autoTimer  = null;

    /* ---- CARD FLICKITY (independent of backgrounds) ---- */
    function waitForFlickity(cb) {
      if (typeof window.Flickity !== 'undefined') { cb(); }
      else { setTimeout(function () { waitForFlickity(cb); }, 50); }
    }

    if (carouselEl && cardTotal > 0) {
      waitForFlickity(function () {
        var existing = window['lpHbcFlickity_' + SECTION_ID];
        if (existing) existing.destroy();

        var flkty = new Flickity(carouselEl, {
          cellAlign: 'center',
          contain: true,
          draggable: cardTotal > 1,
          wrapAround: cardTotal > 1,
          prevNextButtons: false,
          pageDots: false,
          friction: 0.28,
          selectedAttraction: 0.025,
          resize: true
        });

        window['lpHbcFlickity_' + SECTION_ID] = flkty;

        if (prevBtn) prevBtn.addEventListener('click', function () { flkty.previous(true); });
        if (nextBtn) nextBtn.addEventListener('click', function () { flkty.next(true); });

        flkty.on('change', function (idx) {
          cardTexts.forEach(function (t) { t.classList.remove('lp-hbc__card__text--active'); });
          if (cardTexts[idx]) cardTexts[idx].classList.add('lp-hbc__card__text--active');
        });
      });
    }

    /* ---- BACKGROUND AUTO-ROTATE (independent of cards) ---- */
    if (bgTotal <= 1) return;

    function startDotFill(dotIdx) {
      var dot  = bgDots[dotIdx];
      if (!dot) return;
      var fill = dot.querySelector('.lp-hbc__bg-dot__fill');

      bgDots.forEach(function (d) {
        d.classList.remove('lp-hbc__bg-dot--active');
        var f = d.querySelector('.lp-hbc__bg-dot__fill');
        if (f) { f.style.transition = 'none'; f.style.width = '0%'; }
      });

      dot.classList.add('lp-hbc__bg-dot--active');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (fill) {
            fill.style.transition = 'width ' + autoSpeed + 'ms linear';
            fill.style.width = '100%';
          }
        });
      });

      window['lpHbcTimer_' + SECTION_ID] = setTimeout(function () {
        bgs[bgCurrent].classList.remove('lp-hbc__bg--active');
        bgCurrent = bgCurrent + 1 >= bgTotal ? 0 : bgCurrent + 1;
        bgs[bgCurrent].classList.add('lp-hbc__bg--active');
        startDotFill(bgCurrent);
      }, autoSpeed);
    }

    if (bgDots.length > 0) startDotFill(0);

    section.addEventListener('shopify:inspector:activate', function () {
      clearTimeout(window['lpHbcTimer_' + SECTION_ID]);
    });
  }

  /* ---- INIT ON DOM READY ---- */
  function initAll() {
    document.querySelectorAll('[data-section-type="lp-hero-banner-card"]').forEach(initHBC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ---- SHOPIFY SECTION EVENTS ---- */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-section-type="lp-hero-banner-card"]');
    if (s) initHBC(s);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector('[data-section-type="lp-hero-banner-card"]');
    if (!s) return;
    var id = s.dataset.sectionId;
    var flkty = window['lpHbcFlickity_' + id];
    if (flkty) { flkty.destroy(); window['lpHbcFlickity_' + id] = null; }
    clearTimeout(window['lpHbcTimer_' + id]);
  });

})();